import { User } from '../types/dashboard';
import { BackendUser } from '../types/auth';

/**
 * Maps backend user object to frontend User type
 * Transforms role_id from backend API to role string for frontend
 * @param backendUser - User object from backend API
 * @returns Transformed User object for frontend
 */
export const mapBackendUserToFrontend = (backendUser: BackendUser): User => {
  // Map backend role_id to frontend role strings
  const roleMap: Record<number, User['role']> = {
    1: 'trainee',      // Student role
    2: 'trainer',      // Instructor role
    3: 'admin',        // Admin role
    4: 'super_admin'   // Super Admin role
  };

  // Accept either camelCase (`managedTeamIds`) or snake_case (`managed_team_ids`)
  // — backend currently sends camelCase but be lenient.
  const managedTeamIds = Array.isArray(backendUser.managedTeamIds)
    ? backendUser.managedTeamIds
    : Array.isArray(backendUser.managed_team_ids)
      ? backendUser.managed_team_ids
      : [];

  // Same camelCase/snake_case leniency for the new "has reportees" flag.
  const hasReportees =
    typeof backendUser.hasReportees === 'boolean'
      ? backendUser.hasReportees
      : typeof backendUser.has_reportees === 'boolean'
        ? backendUser.has_reportees
        : false;

  const organizations = Array.isArray(backendUser.organizations) ? backendUser.organizations : [];
  const primaryOrganization = backendUser.primaryOrganization || organizations[0] || null;

  // Per-org allowed functionalities (sidebar gating). Left undefined when the
  // backend doesn't send it, which the sidebar treats as "show everything".
  const allowedFeatures = Array.isArray(backendUser.allowedFeatures)
    ? backendUser.allowedFeatures
    : undefined;

  return {
    id: backendUser.uuid,
    name: `${backendUser.first_name} ${backendUser.last_name}`.trim(),
    email: backendUser.email,
    avatar: backendUser.dp,
    role: roleMap[backendUser.role_id] || 'trainee',
    joinedDate: new Date().toISOString(),
    completedCourses: 0,
    currentPoints: 0,
    level: 1,
    managedTeamIds,
    hasReportees,
    organizations,
    primaryOrganization,
    allowedFeatures
  };
};
